import { Box, Text } from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';
import AvailabilityCalendar from 'src/components/Blogs/AvailabilityCalendar.jsx';

/**
 * Embeddable Availability Widget
 * 
 * URL: /embed/availability?slug=upper-pines-campground&theme=green
 * 
 * Query params:
 * - slug (required): The outing slug to display availability for
 * - theme (optional): Accent color - CSS color name (green, teal, blue) or hex (%23FF5733)
 * - days (optional): Number of days to show (default: 7)
 * - buttons (optional): Show "Book on..." and "Get Alerts" buttons (true/false, default: false)
 * - bookingLinks (optional): Enable clickable dates to booking site (true/false, default: false)
 * 
 * Example embed code for bloggers:
 * <iframe 
 *   src="https://reservenature.com/embed/availability?slug=upper-pines-campground&theme=green" 
 *   width="100%" 
 *   height="500" 
 *   frameborder="0"
 *   title="Live Availability - Upper Pines Campground"
 * ></iframe>
 */
export default function Embed() {
  const [searchParams] = useSearchParams();
  
  const slug = searchParams.get('slug');
  const theme = searchParams.get('theme') || 'green'; // Default accent color
  const days = parseInt(searchParams.get('days') || '10', 10);
  const showButtons = searchParams.get('buttons') === 'true';
  const enableBookingLinks = searchParams.get('bookingLinks') === 'true';

  // If no slug provided, show error
  if (!slug) {
    return (
      <Box p={8} textAlign="center" bg="gray.50" minH="200px">
        <Text color="gray.600">
          Missing required parameter: slug
        </Text>
        <Text fontSize="sm" color="gray.500" mt={2}>
          Example: /embed/availability?slug=upper-pines-campground
        </Text>
      </Box>
    );
  }

  return (
    <Box 
      bg="white" 
      minH="100vh" 
      p={[2, 4]}
      // Allow iframe to resize based on content
      overflow="hidden"
    >
      {/* Availability Calendar in Embed Mode */}
      <AvailabilityCalendar 
        slug={slug} 
        daysToShow={days} 
        embedMode={true}
        accentColor={theme}
        showButtons={showButtons}
        enableBookingLinks={enableBookingLinks}
      />
    </Box>
  );
}

